import { useLocation } from 'react-router-dom';

export const useSearchParamValue = (param) => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  return search.get(param);
};
